<template>
  <div>
    <el-table :data="myCourseData" style="width: 100%">
      <el-table-column label="课程" align="center" width="180">
        <template slot-scope="{ row }">
          <!-- {{ row.course }} -->
          <div class="item">
            <a :href="`/course/${row.courseId}`">
              <div class="section">
                <div
                  alt="课程封面"
                  class="img"
                  :style="{
                    height: '162px',
                    'background-image': `url(${fileUrl}/${row.mainImage})`,
                    'background-size': 'cover',
                    'background-color': '#efefef',
                  }"
                ></div>
                <div class="con" style="display: none">
                  <div class="info">
                    <span class="title">{{ row.title }}</span>
                    <!-- <p>
                      {{
                        $store.getters["enums/getSysEnumTextByValue"](
                          "CourseLevel",
                          item.level
                        )
                      }}
                      /
                      {{
                        $store.getters["enums/getSysEnumTextByValue"](
                          "CourseType",
                          item.type
                        )
                      }}
                    </p> -->
                    <!-- <span>200人报名</span> -->
                  </div>
                  <!-- <div class="bottom">
                    <div class="price_con">
                      <span class="free">免费</span>
                    </div>
                  </div> -->
                </div>
              </div>
            </a>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center">
      </el-table-column>
      <el-table-column
        prop="date"
        align="center"
        label="最近学习时间"
        width="220"
      >
      </el-table-column>
      <el-table-column label="订阅" align="center" width="100">
        <template slot-scope="{ row }">
          <el-link v-if="row.state" @click="unSubscribeCourse(row)" target="_blank">取消</el-link>
          <label v-else>取消成功</label>
          <!-- <el-link v-else @click="unSubscribeCourse(row.courseId)" target="_blank">订阅</el-link> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="prev, pager, next"
      :hide-on-single-page="true"
      :total="total"
      :page-size="listQuery.limit"
      @current-change="handleCurrentChange"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import { myCourseService } from "@/api/profiles";
export default {
  name: "Course",
  data() {
    return {
      fileUrl: process.env.VUE_APP_FILE_URL,
      myCourseData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 5,
      },
    };
  },
  created() {
    this.getMyCourse();
  },
  methods: {
    // 获取我的课程
    getMyCourse() {
      myCourseService
        .getMyCoursePageList({
          skipCount: (this.listQuery.page - 1) * this.listQuery.limit,
          maxResultCount: this.listQuery.limit,
        })
        .then((res) => {
          this.myCourseData = res.items;
          this.total = res.totalCount;
        });
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getMyCourse();
    },
    // 取消订阅
    unSubscribeCourse(row) {
      myCourseService.unSubscribeCourse(row.courseId).then((res) => {
        if (res) {
          row.state = false;
        }
      });
    },
  },
};
</script>

<style>
.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: #fff;
}
</style>

<style lang="scss" scoped>
.item {
  cursor: pointer;
  // float: left;
  // margin: 0 20px 20px 0;
  border-radius: 8px;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
  line-height: 0;
  // box-shadow: 0 2px 15px 0 rgba(0,0,0,.1);
  border: 1px solid #dfe6ec;
}

.section {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 158px;
  height: 100px;
  border-radius: 8px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 0;
  overflow: hidden;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
}

.section .img {
  width: 100%;
  max-height: 100px;
  overflow: hidden;

  font-size: 20px;
  line-height: 100px;
  text-align: center;
  color: #999;
}

.section .con {
  position: relative;
  padding: 10px 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 50px;
  border-radius: 0 0 8px 8px;
}

.section .con .info {
  margin: 0;
  padding: 0;
  outline: none;

  height: 30px;
}

.section .con .info .title {
  max-height: 36px;
  font-size: 14px;
  // font-weight: 500;
  color: #333;
  // font-weight: bold;
  font-family: PingFangSC-Medium, PingFangSC;
  line-height: 18px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
